import { Component, OnInit } from "@angular/core";

import { ApiService } from "src/app/api.service";
import { APIResults } from "src/app/sharedinterfaces";

@Component({
	selector: "app-manage-sent-email",
	templateUrl: "./manage-sent-email.component.html",
	styleUrls: ["./manage-sent-email.component.scss"]
})
export class ManageSentEmailComponent implements OnInit {
	public noDelivered = false;
	public totalEmails = 0;
	public currentPage = 1;
	public itemsPerPage = 30;
	public pageEmails: APIResults.SentEmail[] = [];
	public assetList: any[] = [];
	public selectedAsset: any = null;
	public filters: any = {};

	constructor(public api: ApiService) { }

	async ngOnInit() {
		await this.refreshTable();
		const assets = await this.api.GetAllAssets();
		assets.sort((a, b) => (a.fleet_name ?? "").localeCompare(b.fleet_name ?? "") || a.asset_name.localeCompare(b.asset_name));
		this.assetList = assets;
	}

	async refreshTable() {
		this.currentPage = 1;
		await this.updatePage();
	}

	async updatePage() {
		const result = await this.api.GetSentEmails(this.noDelivered, this.filters.asset?.asset_id, this.itemsPerPage * (this.currentPage - 1), this.itemsPerPage);
		this.totalEmails = result.count;
		this.pageEmails = result.rows;
	}

	async FilterAsset(asset: any) {
		this.filters.asset = {
			asset_id: asset.asset_id,
			name: asset.asset_name,
		};
		this.refreshTable();
	}

	removeFilter(field: string) {
		this.filters[field] = null;
		if (field === "asset") this.selectedAsset = null;
		this.refreshTable();
	}
}
